import { type ReactNode } from 'react';

const COLOR_MAP = {
  coral:   { bg: 'bg-coral-50',    text: 'text-coral-600' },
  amber:   { bg: 'bg-amber-50',    text: 'text-amber-600' },
  blue:    { bg: 'bg-blue-50',     text: 'text-blue-600' },
  emerald: { bg: 'bg-emerald-50',  text: 'text-emerald-600' },
  red:     { bg: 'bg-red-50',      text: 'text-red-600' },
  violet:  { bg: 'bg-violet-50',   text: 'text-violet-600' },
  green:   { bg: 'bg-green-50',    text: 'text-green-600' },
  neutral: { bg: 'bg-surface-subtle', text: 'text-muted' },
} as const;

export type StatCardColor = keyof typeof COLOR_MAP;

interface StatCardProps {
  icon: ReactNode;
  value: string | number;
  label: string;
  color?: StatCardColor;
  onClick?: () => void;
}

export const StatCard = ({ icon, value, label, color = 'coral', onClick }: StatCardProps) => {
  const c = COLOR_MAP[color];
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag
      onClick={onClick}
      className="bg-white rounded-xl border border-line p-5 shadow-sm hover:shadow-md transition-shadow text-left"
    >
      <div className={`w-10 h-10 rounded-lg ${c.bg} flex items-center justify-center ${c.text} mb-3`}>
        {icon}
      </div>
      <div className="text-2xl font-semibold text-text tabular-nums">{value}</div>
      <div className="text-xs font-medium text-muted uppercase tracking-wide">{label}</div>
    </Tag>
  );
};
